import { BTStatusBadge } from "@btnet/core-components";

import { type AccountingIntegrationType } from "types/enum";

import { BTCol } from "commonComponents/btWrappers/BTCol/BTCol";
import { BTPopover } from "commonComponents/btWrappers/BTPopover/BTPopover";
import { IntegrationTypeNames } from "commonComponents/financial/Common/Accounting.types";
import { getAccountingLabelText } from "commonComponents/financial/Common/accountingUtils";

import "./AccountingTaxRateConnected.less";

interface IAccountingTaxRateConnectedProps {
    accountingType: AccountingIntegrationType;
}

export const AccountingTaxRateConnected: React.FunctionComponent<
    IAccountingTaxRateConnectedProps
> = ({ accountingType }) => {
    return (
        <BTPopover content={`Originated in ${IntegrationTypeNames.get(accountingType)}`}>
            <BTCol className="accounting-tax-rate-connected accounting-status-tag-container">
                <BTStatusBadge
                    id="taxRateAccountingStatus"
                    testid="taxRateAccountingStatus"
                    text={getAccountingLabelText(accountingType)}
                    displayType="success"
                    textOnly
                />
            </BTCol>
        </BTPopover>
    );
};
